import { render } from "./AnswerPageSeven.vue?vue&type=template&id=c256ab4e&scoped=true"
import script from "./AnswerPageSeven.vue?vue&type=script&lang=js"
export * from "./AnswerPageSeven.vue?vue&type=script&lang=js"

import "./AnswerPageSeven.vue?vue&type=style&index=0&id=c256ab4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c256ab4e"]])

export default __exports__